import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, InlineRangeAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectFloornFilter } from 'shared/selectors/advancedFilters';

export const FloorBuildingContainer: FC = () => {
  const {
    value: { min: valueMin, max: valueMax },
    min,
    max,
  } = useSelector(selectFloornFilter);

  const onChange = useFilterChangeCallback();

  const handleMinChange = useCallback(
    (newMin: number | null) => {
      onChange({ action: 'setFloorn', arguments: [newMin, valueMax] });
    },
    [onChange, valueMax],
  );

  const handleMaxChange = useCallback(
    (newMax: number | null) => {
      onChange({ action: 'setFloorn', arguments: [valueMin, newMax] });
    },
    [onChange, valueMin],
  );

  return (
    <AdvancedFilterRow label="Этажей в здании">
      <InlineRangeAdvancedFilter
        min={min}
        max={max}
        valueMin={valueMin}
        valueMax={valueMax}
        onMinChange={handleMinChange}
        onMaxChange={handleMaxChange}
      />
    </AdvancedFilterRow>
  );
};
